import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Avatar,
} from "antd";
import "./index.css";
import {State, City } from "country-state-city";
import { firestore, storage } from "../../config/firebase";
import { PieChart } from "react-minimal-pie-chart";
import {
  ref,
  uploadBytes,
  getDownloadURL,
  deleteObject,
} from "firebase/storage";
import { v4 as uuidv4 } from "uuid";
import {
  updateDoc,
  doc,
  getDoc,
} from "firebase/firestore";

import {
  EditOutlined,
 
  UserOutlined,
} from "@ant-design/icons";
import Select from "react-select";
import { regexPattern } from "../../utils/constants";
import { colors } from "../../utils/color";
import axios from "axios";
import { base_url } from "../counsellor/userReviews";
import CircularProgress from "@mui/material/CircularProgress";

const UserProfile = () => {

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    state: "",
    city: "",
  });
  const [stateList, setStateList] = useState([]);
  const [dataLoading, setDataLoading] = useState(false);
  const [cityList, setCityList] = useState([]);
  const [stateCode, setStateCode] = useState("");
  const [errors, setErrors] = useState({});
  const [selectedImage, setSelectedImage] = useState(null);

  
  const navigate = useNavigate();
  const location = useLocation();
  const fileInputRef = useRef(null);

  
  const selectedUser = location.state?.selectedUser || null;
 

  const handleValidation = () => {
    const newErrors = {};
    if (!formData.firstName || formData.firstName === "")
      newErrors.fName = "First name is required";
    else if (formData.firstName.length < 3 || formData.firstName.length > 50)
      newErrors.fName = "First name must be 3 to 50 characters long";

    if (!formData.lastName || formData.lastName === "")
      newErrors.lName = "Last name is required";
    else if (formData.lastName.length < 3 || formData.lastName.length > 50)
      newErrors.lName = "Last name must be 3 to 50 characters long";
    if (!formData.city || formData.city === "") newErrors.city = "Select city";
    if (!formData.state || formData.state === "")
      newErrors.state = "Select state";
    return Object.keys(newErrors).length === 0;
  };


  useEffect(() => {
    if (Object.keys(errors).length > 0) {
      const timeoutId = setTimeout(() => {
        setErrors({});
      }, 5000);

      // Clean up the timeout on component unmount
      return () => clearTimeout(timeoutId);
    }
  }, [errors]);


  const handleOnChange = (e) => {
    if (regexPattern.test(e.target.value)) {
      if (e.target.name === "firstName") {
        setFormData({ ...formData, firstName: e.target.value });
      } else setFormData({ ...formData, lastName: e.target.value });
    }
  };

  useEffect(() => {
    if (!stateList.length) {
      setStateList([
        ...State.getStatesOfCountry("IN").map((el, index) => {
          return { value: el.isoCode, label: el.name };
        }),
      ]);
    }
  }, [stateList]);

  useEffect(() => {
    if (stateCode) {
      setCityList([
        ...City.getCitiesOfState("IN", stateCode).map((el) => {
          return { label: el.name };
        }),
      ]);
    }
  }, [stateCode]);

  const handleUpdateCounsellor = async () => {
    let validation = handleValidation();
    if (validation) {
      try {
     
        const updatedData = {
          firstName: formData.firstName,
          lastName: formData.lastName,
          city: formData.city,
          state: formData.state,
        };

        await updateDoc(doc(firestore, "users", selectedUser.id), updatedData);
        navigate("/userlist");
      } catch (error) {
        alert("Cannot perform this action.Try again");
      }
    }
    else{
      console.log("Validate-------")
    }
  };

  const handleFileInputChange = async (e) => {
    const selectedFile = e.target.files[0];

    if (selectedFile) {
      let oldImageUrl = null;
      const adminDocRef = doc(firestore, "users", selectedUser.id);
      const adminDocSnapshot = await getDoc(adminDocRef);

      if (adminDocSnapshot.exists()) {
        const data = adminDocSnapshot.data();
        oldImageUrl = data.image || null;
      }

      if (oldImageUrl) {
        const oldImageRef = ref(storage, oldImageUrl);
        try {
          await deleteObject(oldImageRef);
        } catch (deleteError) {
          console.error("Error deleting old image:", deleteError);
        }
      }

      const uniqueFilename = `${Date.now()}-${uuidv4()}`;
      const storageRef = ref(storage, `user_images/${uniqueFilename}`);
      uploadBytes(storageRef, selectedFile)
        .then((snapshot) => getDownloadURL(snapshot.ref))
        .then((downloadURL) => {
          setSelectedImage(downloadURL);
          return updateDoc(adminDocRef, {
            image: downloadURL,
          });
        })
        .then(() => {
          console.log("Image URL updated in Firestore");
        })
        .catch((error) => {
          console.error("Error uploading image:", error);
        });
    }
  };

  const handleEditIconClick = (e) => {
    e.stopPropagation();
    fileInputRef.current.click();
  };


const getUserDetails=async()=>{
  setDataLoading(true)
  const payload={userId:selectedUser.uuid,uuid:selectedUser.id}
  try {
    const response=await axios.post(base_url+"/user-profile",payload) 
    const result=response.data
    setFormData(result);
    setSelectedImage(result.image);
    setDataLoading(false)
  }
catch(er){
  setDataLoading(false)
  console.log("Error in api",er)
}
  }
useEffect(()=>{
  
  getUserDetails()
},[])

const calculateTime = (time) => {
  // Calculate hours, minutes, and remaining seconds
  const hours = Math.floor(time / 3600);
  const minutes = Math.floor((time % 3600) / 60);
  const seconds = time % 60;

  if (hours > 0) {
    return `Avg time: ${hours}h ${minutes}m ${seconds}s`;
  } else {
    return `Avg time: ${minutes}m ${seconds}s`;
  }
}  
  return (
   
    <div className="form-container-main">
     
      {dataLoading?<div className="circular-container"> <CircularProgress size={30} /></div>: <React.Fragment>
<div
        style={{
          position: "relative",
        }}
      >
        <Avatar
          size={64}
          icon={<UserOutlined />}
          style={{ position: "relative" }}
          onClick={handleEditIconClick}
          src={selectedImage}
          alt="Selected"
        ></Avatar>

        <input
          type="file"
          ref={fileInputRef}
          style={{ display: "none" }}
          onChange={(e) => handleFileInputChange(e)}
        />

        <EditOutlined
          style={{
            position: "absolute",
            bottom: 10,
            zIndex: 4,
          }}
          onClick={handleEditIconClick}
        />
      </div>
      <div style={{ flexDirection: "row", display: "flex" }}>
        <div className="form" style={{ boxShadow: "none" }}>
          <label>
            First Name:
            <input
              type="text"
              name="firstName"
              value={formData.firstName}
              onChange={handleOnChange}
            />
            <span className="errors">{errors.fName ?? " "}</span>
          </label>
          <label>
            Last Name:
            <input
              type="text"
              name="lastName"
              value={formData.lastName}
              onChange={handleOnChange}
            />
            <span className="errors">{errors.lName ?? " "}</span>
          </label>
          <label>
            Email:
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={(e) =>
                setFormData({ ...formData, email: e.target.value })
              }
              disabled
            />
            <span className="errors">{errors.email ?? " "}</span>
          </label>
          <label>
            Phone:
            <input
              type="tel"
              name="phone"
              value={formData.phone}
              disabled
            />
            <span className="errors">{errors.phone ?? " "}</span>
          </label>
          <label>
            State:
            <Select
            defaultValue={formData.state}
              onChange={async (a) => {
                setStateCode(a.value);
                setFormData({ ...formData, state: a.label });
              }}
              options={stateList}
              placeholder={formData.state}
            />
            <span className="errors">{errors.state ?? " "}</span>
          </label>

          <label>
            City:
            <Select
              defaultValue={formData.city}
              onChange={async (a) => {
                setFormData({ ...formData, city: a.label });
              }}
              options={cityList}
              placeholder={formData.city}
            />
            <span className="errors">{errors.city ?? " "}</span>
          </label>

          <button
            type="submit"
            onClick={() => handleUpdateCounsellor()}
            disabled={selectedUser === formData}
          >
            Update
          </button>
        </div>
        <div className="stats-section">
          <div className="stats-sub-section">
            <span className="head-text">Total Calls</span>
            <div className="graph-container">
              <span className="sub-head-text">{formData.callCount+'/'+formData.totalCount}</span>
              <PieChart
                data={[
                  {
                    title: "Calls",
                    value: Math.floor((formData.callCount / formData.totalCount) * 100),
                    color: "#A8CBD8",
                  },
                ]}
                style={{ height: 60, width: 60 }}
                totalValue={100}
                background={colors.primary}
              />
               
            </div>
           
              <span className="sub-head-text-2">
                 {calculateTime(formData.totalCallTime)}
              </span>
            
          </div>
          <div className="stats-sub-section">
            <span className="head-text">Total Chats</span>
            <div className="graph-container">
              <span className="sub-head-text">{formData.chatCount+'/'+formData.totalCount}</span>
              <PieChart
                data={[
                  {
                    title: "Calls",
                    value: Math.floor((formData.chatCount / formData.totalCount) * 100),
                    color: "#A8CBD8",
                  },
                ]}
                style={{ height: 60, width: 60 }}
                totalValue={100}
                background={colors.primary}
              />
            </div>
            
              <span className="sub-head-text-2">
                {calculateTime(formData.totalChatTime)}
              </span>
           
          </div>
         
        </div>
      </div>
    </React.Fragment>}
    </div>
  );
};

export default UserProfile;
